import { render, staticRenderFns } from "./AccessibilityOverlay.vue?vue&type=template&id=1438e1ae&scoped=true"
import script from "./AccessibilityOverlay.vue?vue&type=script&lang=js"
export * from "./AccessibilityOverlay.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityOverlay.vue?vue&type=style&index=0&id=1438e1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438e1ae",
  null
  
)

export default component.exports